module.exports = __webpack_public_path__ + "img/Speaker=Aubrey de Grey.2b9e8639.png";